<template>
  <div class="footer">
    <div class="footer-nav">
      <ul>
        <router-link tag="li" :to="'/wall'">
          <svg
            xmlns="http://www.w3.org/2000/svg"
            xmlns:xlink="http://www.w3.org/1999/xlink"
            width="24"
            height="24"
            viewBox="0 0 24 24"
          >
            <g transform="translate(364 -1007.333)">
              <path
                class="c"
                d="M18.377-12.558,16.5-14.1v-3.078a.258.258,0,0,0-.258-.258H15.211a.259.259,0,0,0-.256.254v1.812l-4.518-3.709A2.1,2.1,0,0,0,9.282-19.5a2.1,2.1,0,0,0-1.156.418L.186-12.558a.585.585,0,0,0-.185.4.6.6,0,0,0,.12.331l.33.4a.585.585,0,0,0,.4.185.6.6,0,0,0,.331-.12l.885-.727v6A1.036,1.036,0,0,0,3.094-5.062H7.219A1.036,1.036,0,0,0,8.25-6.093V-9.445h2.063v3.352a1.036,1.036,0,0,0,1.031,1.031h4.125A1.036,1.036,0,0,0,16.5-6.086V-12.1l.887.729a.6.6,0,0,0,.331.12.585.585,0,0,0,.4-.185l.33-.4a.6.6,0,0,0,.12-.331A.585.585,0,0,0,18.377-12.558ZM14.949-6.609H11.86V-9.961a1.036,1.036,0,0,0-1.031-1.031H7.735A1.036,1.036,0,0,0,6.7-9.961v3.352H3.61v-6.759l5.672-4.661,5.672,4.659Z"
                transform="translate(-361.001 1031.832)"
              />
            </g>
          </svg>
          <span>{{$t('Home')}}</span>
        </router-link>

        <router-link tag="li" :to="'/searchall-businesslist'">
          <svg
            xmlns="http://www.w3.org/2000/svg"
            xmlns:xlink="http://www.w3.org/1999/xlink"
            width="24"
            height="24"
            viewBox="0 0 24 24"
          >
            <g class="b" transform="translate(412 -1007.333)">
              <path
                class="c"
                d="M18.763-3.7l-4.48-4.48a.438.438,0,0,0-.314-.129h-.487a7.654,7.654,0,0,0,1.867-5.018A7.674,7.674,0,0,0,7.675-21,7.674,7.674,0,0,0,0-13.325,7.674,7.674,0,0,0,7.675-5.65a7.654,7.654,0,0,0,5.018-1.867v.487a.454.454,0,0,0,.129.314l4.48,4.48a.443.443,0,0,0,.627,0l.834-.834A.443.443,0,0,0,18.763-3.7ZM7.675-7.421a5.9,5.9,0,0,1-5.9-5.9,5.9,5.9,0,0,1,5.9-5.9,5.9,5.9,0,0,1,5.9,5.9A5.9,5.9,0,0,1,7.675-7.421Z"
                transform="translate(-409 1031)"
              />
            </g>
          </svg>
          <span>{{$t('AllAddas')}}</span>
        </router-link>

        <router-link tag="li" :to="'/notification'">
          <svg
            xmlns="http://www.w3.org/2000/svg"
            xmlns:xlink="http://www.w3.org/1999/xlink"
            width="24"
            height="24"
            viewBox="0 0 24 24"
          >
            <g class="b" transform="translate(412 -1007.333)">
              <g transform="translate(-409 1010.333)">
                <path
                  class="c"
                  d="M9.281,18.56A2.541,2.541,0,0,1,7.091,17.3a.844.844,0,0,1,.73-1.267h2.92a.844.844,0,0,1,.73,1.267A2.538,2.538,0,0,1,9.281,18.56Zm8.438-4.217H.843a.844.844,0,0,1,0-1.687,1.689,1.689,0,0,0,1.687-1.687V6.75a6.75,6.75,0,0,1,13.5,0v4.218a1.689,1.689,0,0,0,1.688,1.688.844.844,0,0,1,0,1.688ZM9.281,1.688A5.068,5.068,0,0,0,4.218,6.75v4.218a3.371,3.371,0,0,1-.451,1.688H14.8a3.373,3.373,0,0,1-.452-1.687V6.75A5.068,5.068,0,0,0,9.281,1.688Z"
                />
              </g>
            </g>
          </svg>
          <span>{{$t('Notification')}}</span>
        </router-link>

        <router-link tag="li" :to="'/profile'">
          <svg
            xmlns="http://www.w3.org/2000/svg"
            xmlns:xlink="http://www.w3.org/1999/xlink"
            width="24"
            height="24"
            viewBox="0 0 24 24"
          >
            <g class="b" transform="translate(412 -1007.333)">
              <path
                class="c"
                d="M8.266-10.373a5.315,5.315,0,0,0,5.314-5.314A5.315,5.315,0,0,0,8.266-21a5.315,5.315,0,0,0-5.314,5.314A5.315,5.315,0,0,0,8.266-10.373Zm0-8.856a3.548,3.548,0,0,1,3.542,3.542,3.548,3.548,0,0,1-3.542,3.542,3.548,3.548,0,0,1-3.542-3.542A3.548,3.548,0,0,1,8.266-19.229Zm3.306,9.447a3.649,3.649,0,0,0-1.188.229,6.4,6.4,0,0,1-2.118.362,6.4,6.4,0,0,1-2.118-.362,3.649,3.649,0,0,0-1.188-.229A4.961,4.961,0,0,0,0-4.823v1.83a.883.883,0,0,0,.886.886.883.883,0,0,0,.886-.886v-1.83A3.184,3.184,0,0,1,4.723-7.989a9.869,9.869,0,0,1,1.181.2,8.159,8.159,0,0,0,2.362.373,8.139,8.139,0,0,0,2.362-.373c.65-.245.759-.3,1.173-.192a3.182,3.182,0,0,1,2.952,3.166v1.827a.883.883,0,0,0,.886.886.883.883,0,0,0,.886-.886v-1.83A4.95,4.95,0,0,0,11.572-9.782Z"
                transform="translate(-408 1031)"
              />
            </g>
          </svg>
          <span>{{$t('Profile')}}</span>
        </router-link>
      </ul>
    </div>
  </div>
</template>

<script>
import { mapState } from "vuex";
export default {
  name: "Footer",
  data() {
    return {};
  },
  computed: {
    ...mapState(["withQRfooter", "titleFooter"])
  }
};
</script>

<style></style>
